export const contactsData = {
  email: "anupkafle02@gmail.com",
  phone: "+977 9866049188",
  address: "Koteshwor - 32, Kathmandu, Nepal ",

  sheetAPI:
    "https://docs.google.com/spreadsheets/d/1FPwfBeHGSSz_7cgojNEqK9ozbEzGSwtCpn8PJZEJ8UY/edit#gid=0",
};
